import { render, staticRenderFns } from "./claimsInfo.vue?vue&type=template&id=5e1fab8b&scoped=true"
import script from "./claimsInfo.vue?vue&type=script&lang=js"
export * from "./claimsInfo.vue?vue&type=script&lang=js"
import style0 from "./claimsInfo.vue?vue&type=style&index=0&id=5e1fab8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fab8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1fab8b')) {
      api.createRecord('5e1fab8b', component.options)
    } else {
      api.reload('5e1fab8b', component.options)
    }
    module.hot.accept("./claimsInfo.vue?vue&type=template&id=5e1fab8b&scoped=true", function () {
      api.rerender('5e1fab8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/claimsInfo.vue"
export default component.exports